import propTypes from "prop-types";
import React from "react";

export default class FileDragAndDrop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayState: "empty",
    };
  }

  componentDidMount() {
    // checking if the component came with a file
    const { file, formats } = this.props;
    if (file) {
      this.setState({
        displayState: this.validateFile(file, formats || [])
          ? "complete"
          : "empty",
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.file && this.props.file === null) {
      this.setState({
        displayState: "empty",
      });
    }
  }

  handleDragEnter = () => {
    if (this.state.displayState === "complete") return;

    this.setState({ displayState: "over" });
  };

  handleDragLeave = () => {
    const { file } = this.props;
    this.setState({ displayState: file ? "complete" : "empty" });
  };

  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  validateFile = (file, formats = []) => {
    return (
      !formats.length ||
      formats.some((format) => file.name.toLowerCase().endsWith(format))
    );
  };

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { formats } = this.props;

    if (this.state.displayState === "complete") return;

    const files = [...e.dataTransfer.files];

    if (!this.validateFile(files[0], formats || [])) {
      this.setState({
        displayState: "error",
        error: `Only following file formats are acceptable: ${formats.join(
          ", "
        )}`,
      });
      setTimeout(() => {
        this.setState({ displayState: "empty" });
      }, 1000);

      return;
    }
    if (files && files.length) {
      this.props.onChange(files[0]);
      this.setState({ displayState: "complete" });
    }
  };

  render() {
    const { file, promptText, onChange } = this.props;
    const { displayState, error } = this.state;
    return (
      <div
        onDragEnter={this.handleDragEnter}
        onDragLeave={this.handleDragLeave}
        onDragOver={this.handleDragOver}
        onDrop={this.handleDrop}
        className={`${displayState === "complete" && "complete-drop-mat"} ${
          displayState === "over" ? "active-drop-mat" : "empty-drop-mat"
        } ${displayState === "error" && "error-drop-mat"} `}
      >
        {(displayState === "empty" || displayState === "over") && promptText}
        {displayState === "error" && error}
        {displayState === "complete" && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span className="mr-2">{file?.name}</span>{" "}
            <span
              className="fas fa-times danger-text mt-1"
              title="Remove file"
              onClick={() => {
                onChange(null);
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

FileDragAndDrop.propTypes = {
  file: propTypes.instanceOf(File),
  onChange: propTypes.func.isRequired,
  promptText: propTypes.string,
  formats: propTypes.arrayOf(propTypes.string),
};
